import { AllowedEvent } from '@rbilabs/intl-mparticle-client';
import { IntlShape } from 'react-intl';

import { CustomEventNames, EventTypes } from 'state/cdp/constants';

import { PromoCodeError, PromoCodeErrorReason } from './types';

export const createRbiApplyPromoCodeEvent = (
  promoCode: string,
  response: 'Successful' | 'Failed',
  failureReason?: PromoCodeErrorReason
): AllowedEvent => ({
  name: CustomEventNames.ACTION_SHEET_SUBMISSION,
  type: EventTypes.Other,
  attributes: {
    actionSheetHeader: 'Apply Promo Code',
    response,
    failureReason,
    submittedData: promoCode,
  },
});

export const buildErrorMessageFromPromoCodeError = (
  promoCodeError: PromoCodeError,
  formatMessage?: IntlShape['formatMessage']
) => {
  switch (promoCodeError.message) {
    case PromoCodeErrorReason.expiredCode:
      return formatMessage
        ? formatMessage({ id: 'promoCodeOfferExpiredCode' })
        : 'promoCodeOfferExpiredCode';
    case PromoCodeErrorReason.redeemedCode:
      return formatMessage
        ? formatMessage({ id: 'promoCodeOfferRedeemedCode' })
        : 'promoCodeOfferRedeemedCode';
    case PromoCodeErrorReason.userNotEligible:
      return formatMessage
        ? formatMessage({ id: 'promoCodeOfferUserNotEligible' })
        : 'promoCodeOfferUserNotEligible';
    default:
      return formatMessage
        ? formatMessage({ id: 'promoCodeOfferInvalidCode' })
        : 'promoCodeOfferInvalidCode';
  }
};
